<template>
  <div v-loading="loading" class="page-form">
    <h3 class="title">发货计划调整批量导入审批</h3>

    <div class="form-container">
      <div class="tools">
        <btky-header
          :form-data="conditions"
          :process-key="processKey"
          @validate="validate"
          @formDataSave="saveData"
        />
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        label-width="100px"
        :disabled="isEdit"
        :model="conditions"
        :rules="rules"
      >
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item prop="billCode" class="widget-view" label="申请单号" label-width="">
              <el-input
                v-model="conditions.billCode"
                disabled
                placeholder="自动生成"
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="billType" class="widget-view" label="创建人" label-width="">
              <el-input
                v-model="conditions.createdByName"
                disabled
                placeholder="请输入"
                type="text"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="createdDate" class="widget-view" label="创建时间" label-width="">
              <el-input v-model="conditions.createdDate" disabled placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" prop="zyxdy" label="营销单元" label-width="">
              <el-select
                v-model="conditions.zyxdy"
                placeholder="请选择"
                clearable
                disabled
                suffix-icon="el-icon-more"
                @change="onChangeYxdy"
              >
                <el-option
                  v-for="item in saleList"
                  :key="item.SOBID"
                  :value="item.SOBID"
                  :label="item.MC_SHORT"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="调整信息" :custome-config="() => vxeShowCustom('xTable')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="medium"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :edit-rules="validRules"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #zqdlx="{ row }">
            <el-select
              v-model="row.zqdlx"
              disabled
            >
              <el-option
                v-for="selectItem in selectDataOptions['goodsPlanType']"
                :key="selectItem.value"
                :value="selectItem.value"
                :label="selectItem.name"
              />
            </el-select>
          </template>
        </vxe-grid>
      </TableCommon>
      <btky-footer :form-data="conditions" />
    </div>

    <!-- <btky-footer :form-data="conditions" /> -->

    <!-- 通用弹窗情况 -->
    <el-dialog v-dialogDrag :title="dialogTitle" :visible.sync="showDialog" width="70%" :append-to-body="true">
      <template v-if="showDialog">
        <client-select v-if="dialogTitle === '客户选择'" ref="dialogSelect" />
        <product-select
          v-if="dialogTitle === '产品选择'"
          ref="dialogSelect"
          :query-params="{ customerCode: conditions.partner }"
        />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="submitHandle"
        >提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiMonthplanChangeImportFindById } from '@/api/applyForGoods/monthly'
import { handlerFlow } from '@/api/flowHander'
import { getToken } from '@/utils/auth'
import { DOWNLOAD_API } from '@/api/baseUrl'
import { apiSapClientFindInfo, apiExportExcelTemplate, apiExcelImport, apiGetExcelImportData } from '@/api/common'
import { apiGetOrgOrBase } from '@/api/sap/common-sap'
import { mapGetters } from 'vuex'
const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')
const ProductSelect = () => import('@/components/dialog/ProductSelect.vue')

const rules = {
 // zyxdy: [{ required: true, message: '请选择营销单元', trigger: 'change' }]
}

export default {
  components: { ClientSelect, ProductSelect },
  data() {
    return {
      rules,
      loading: false,
      processKey: 'ztcrmTgpplanM2Import',
      dialogTitle: '',
      showDialog: false,
      validRules: {},
      conditions: {
        id: '',
        bizId: '',
        taskId: '',
        zyear: '',
        p: '',
        businessType: 'import',
        partner: '',
        status: 0,
        billCode: '',
        partnerName: '',
        customerType: '',
        createdDate: '',
        createdByName: '',
        m2List: []
      },
      importConfig: {
        templateCode: 'monthPlanAdjuesImport',
        batchNumber: ''
      },
      saleList: [],
      selectDataOptions: {},
      currentRow: null,
      gridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          { field: 'partner', title: '客户编码', width: 120 },
          { field: 'partnerName', title: '客户名称', width: 120 },
          { field: 'brand', title: '存货分类', width: 120 },
          { field: 'brandName', title: '存货分类描述', width: 120 },
          { field: 'zqdlx', title: '渠道类型', width: 120, slots: { default: 'zqdlx' }},
          { field: 'zyxdy', title: '营销单元', width: 120 },
          { field: 'zyxdyName', title: '营销单元名称', width: 120 },
          { field: 'annual', title: '实际年度', width: 120 },
          { field: 'monthly', title: '月份', width: 120 },
          { field: 'deliveryNum', title: '计划量', width: 120 },
          { field: 'approvingNum', title: '发货量(审核中)', width: 120 },
          { field: 'usedNum', title: '发货量(归档中)', width: 120 },
          { field: 'remainNum', title: '剩余量', width: 120 },
          { field: 'adjustDeliveryNum', title: '本次调整量', width: 120 },
          { field: 'finalNum', title: '调整计后量', width: 120 },
          { field: 'adjustReason', title: '调整原因', width: 120 }
        ],
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    isEdit() {
      return false
    }
  },
  watch: {
    'gridOptions.data': {
      handler(newVal) {
        this.conditions.m2List = newVal
      },
      deep: true
    }
  },
  created() {
    this.getSelectDictDataOrigin('goodsPlanType')
    this.conditions.createdByName = this.userInfo.name
    this.conditions.createdDate = this.$utilsCommon.parseTime(new Date().getTime(), '{y}-{m}-{d}')
    const { id, taskId } = this.$route.query
    if (id) {
      this.conditions.id = id
      this.conditions.bizId = id
      taskId && (this.conditions.taskId = taskId)
      this.initDetail()
    } else {
      this.initCustome()
    }
    apiGetOrgOrBase().then(res => {
      this.saleList = res.DATA
    })
  },
  methods: {
    // 查询客户信息
    async initCustome() {
      const params = { rt_partner: [{
        SIGN: 'I',
        OPTION: 'EQ',
        LOW: '0050000215',
        HIGH: ''
      }], page: 1, pagesize: 50 }
      // 当前登录账号和角色
      params.partner = this.$store.getters.role.USER_BP
      params.role = this.$store.getters.role.ROLE
      const { data } = await apiSapClientFindInfo(params)
      this.$set(this.selectDataOptions, 'orgList', data[0]?.yxdy || [])
    },
    initDetail() {
      apiMonthplanChangeImportFindById(this.conditions).then(res => {
        Object.assign(this.conditions, res.data)
        this.gridOptions.data = res.data.m2List || []
        this.initCustome()
      })
    },
    saveData() {
      const params = JSON.parse(JSON.stringify(this.conditions))
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          handlerFlow(params, this.processKey)
            .then(response => {
              this.loading = false
              if (!this.conditions.id) {
                this.conditions.id = response.data.bizId
                Object.assign(this.conditions, response.data.bizData)
                this.conditions.bizId = response.data.bizId
                this.conditions.taskId = response.data.taskId
                this.conditions.billCode = response.data.bizData.billCode
              }
              response.data.bizData.m2List.map(item => {
                item.zyxdyOptions = this.selectDataOptions['orgList']
              })
              this.gridOptions.data = response.data.bizData.m2List
              this.$message.success('保存成功')
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },
    openDialog(e, title, currentRow) {
      e.target.blur()
      this.showDialog = true
      this.dialogTitle = title
      currentRow && (this.currentRow = currentRow)
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()

      if (!data) return
      if (this.dialogTitle === '客户选择') {
        this.conditions.partner = data.customerCode
        this.conditions.partnerName = data.customerName
        this.conditions.customerType = data.customerType
        this.$set(this.selectDataOptions, 'orgList', data.orgList)
      } else {
        this.currentRow.productId = data.productCode
        console.log(data)
      }
      this.showDialog = false
    },
    validate(cb) {
      this.$refs['form'].validate(valid => {
        if (valid) {
          cb()
        }
      })
    },
    insertData() {
      const columns = this.gridOptions.columns.filter(v => !v.type)
      const data = {}
      for (const key in columns) {
        data[columns[key].field] = '1'
      }
      data.zyxdyOptions = this.selectDataOptions['orgList']
      this.gridOptions.data.unshift(data)
    },
    async removeData() {
      const checkedList = this.$refs.xTable.getCheckboxRecords()
      checkedList.forEach(item => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 导入excel
    async handleImportExcel() {
      this.$refs.xTable
        .readFile({
          types: ['xlsx']
        })
        .then(async resp => {
          const { files } = resp
          const formData = new FormData()
          Array.from(files).forEach(file => {
            formData.append('file', file)
          })
          const params = {
            formData,
            templateCode: this.importConfig.templateCode
          }
          const res = await apiExcelImport(params)
          if (res?.status === 1) {
            this.importConfig.batchNumber = res.data
            this.handleQueryImportExcel(res.data)
          }
        })
    },
    // 查询导入excel数据
    async handleQueryImportExcel() {
      const { page, pagesize } = this.importConfig
      const params = { ...this.importConfig, page, pagesize }
      const res = await apiGetExcelImportData(params)
      console.log(res.data.Rows)
      this.gridOptions.data = res.data.Rows
    },
    // 营销单元选择事件
    onChangeYxdy(data) {
      const org = this.selectDataOptions['orgList'].find(v => {
        v.zzfld00001h === data
      })
      if (data) {
        this.conditions.zyxdyName = org.mc_short
      } else {
        this.conditions.zyxdyName = ''
      }
    },
    // 模板下载
    async downloadTemplate() {
      const res = await apiExportExcelTemplate(this.importConfig.templateCode)
      if (res?.status !== 0) {
        return
      }
      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data.file
      }&authToken=${getToken()}`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.target = '_blank'
      // link.setAttribute('download', '模板')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 10px;
  text-align: left;
  .blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/deliveryPlanChangeImportApprove.vue